module.exports = __webpack_public_path__ + "static/media/icon_dropDown_white.04bdbe33.svg";